/* Veltari Build Stages configurator: vehicle > stage > select, skip or swap each component > optional add-ons > review > real cart.
   Data comes from the section's JSON (Shopify products, variants, prices, stock and the savings ladder). Nothing here edits a displayed price:
   the cart receives the real variants, and any package discount has to be applied by Shopify at checkout. */
(function () {
  'use strict';
  var Core = window.VltPackageCore;
  if (!Core) return;

  var VEH_KEY = 'vlt-build-vehicle';
  var SEL_KEY = 'vlt-build-sel:';
  var EXHAUST_ORDER = ['Full Catback', 'Midpipe', 'Axleback'];
  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var T = {
    flow: ['Vehicle', 'Stage', 'Build', 'Review'],
    vehicleH: 'Choose your vehicle',
    vehicleP: 'Pick your BMW and we will show the parts listed for it.',
    noVehicles: 'No vehicles are set up yet.',
    stageH: 'Choose your stage',
    stageP: 'Each stage builds on the one before it. For every part you can select a product, skip it if you already own it, or swap it for another approved carbon part.',
    stepOf: 'Step {n} of {total}',
    stepP: 'Choose one {category} listed for {vehicle}.',
    addonsH: 'Optional add-ons',
    addonsP: 'Lighting, interior and smaller accessories. They are optional and do not count toward your carbon savings.',
    reviewH: 'Review your build',
    reviewP: 'Check each part, then add the whole package to your cart.',
    doneH: 'Package added to your cart',
    addShort: 'Add to cart', select: 'Select', selected: 'Selected', update: 'Update selection', soldOut: 'Sold out', optionSoldOut: 'Option sold out',
    chooseStage: 'Choose stage', chooseVehicle: 'Select',
    back: 'Back', stages: 'Stages', next: 'Continue', review: 'Review build', add: 'Add package to cart', adding: 'Adding to cart...',
    viewCart: 'View cart', checkout: 'Checkout', buildAnother: 'Build another'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function num(v, d) { var n = Number(v); return isFinite(n) ? n : d; }
  function fmtPct(n) { return String(Math.round(n * 100) / 100) + '%'; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function readLS(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function writeLS(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* storage blocked: the build still works for this visit */ } }
  /* Make sure a message ends like a sentence before more text is added after it. */
  function sentence(t) {
    t = String(t == null ? '' : t).replace(/\s+$/, '');
    return /[.!?]$/.test(t) ? t : t + '.';
  }
  /* Customer-friendly text for a failed POST /cart/add.js (Shopify sends {message, description}). */
  function cartErrorText(b) {
    var d = String((b && (b.description || b.message)) || '');
    if (/cannot find variant/i.test(d)) return 'One of the parts in this build is no longer available. Please reload the page and choose again.';
    return d || 'We could not add this package. Please try again.';
  }
  function makeMoney(currency, locale) {
    var f = null;
    try { f = new Intl.NumberFormat(currency === 'AUD' ? 'en-AU' : (locale || undefined), { style: 'currency', currency: currency || 'AUD' }); } catch (e) { f = null; }
    return function (cents) {
      var n = (Number(cents) || 0) / 100;
      return f ? f.format(n) : (currency || '') + ' ' + n.toFixed(2);
    };
  }
  function headerH() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--m-header-height'));
    return isFinite(v) ? v : 80;
  }

  function App(host) {
    var root = host.querySelector('[data-vb-app]');
    var dataEl = host.querySelector('script[data-vb-data]');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) {
      root.innerHTML = `<p class='vb-empty'>The builder could not load. Please refresh the page.</p>`;
      return;
    }
    var money = makeMoney(data.currency, data.locale);
    var design = !!data.designMode;
    var routes = data.routes || {};
    var set = data.settings || {};
    var live = !!set.live;
    var previewing = !live && !!data.preview;
    var tiers = Core.cleanTiers(data.tiers);
    var showSavings = tiers.length > 0 && (live || previewing);
    var topParts = Core.maxParts(tiers);
    /* Amounts typed into the admin (swap price floor, exhaust offer cap) are in the shop currency; prices on the page are in the shopper's currency. */
    var rate = 1;
    if (data.shopCurrency && data.currency && data.shopCurrency !== data.currency) {
      var rr = window.Shopify && window.Shopify.currency ? Number(window.Shopify.currency.rate) : 0;
      rate = rr > 0 ? rr : 0;
    }
    function shopToMinor(amount) { return rate > 0 ? Math.round(num(amount, 0) * rate * 100) : null; }
    var swapMin = shopToMinor(set.swapMin);
    if (swapMin === null) swapMin = 0;

    var vehicles = (data.vehicles || []).slice().sort(function (a, b) { return num(a.order, 1e6) - num(b.order, 1e6); });
    var stages = (data.stages || []).slice().sort(function (a, b) { return num(parseInt(a.number, 10), 1e6) - num(parseInt(b.number, 10), 1e6); });
    var cats = data.categories || {};
    var prods = data.products || {};
    var swapList = data.swap || [];
    var vById = {}, sById = {}, inCatalog = {}, carbonOrder = [];
    vehicles.forEach(function (v) { vById[v.handle] = v; });
    stages.forEach(function (s) { sById[s.handle] = s; });
    function prep(p, i) {
      p._i = i;
      p.fit = p.fit || [];
      p.variants.forEach(function (v) { v.price = num(v.price, 0); });
      p._avail = p.variants.some(function (v) { return v.available; });
      var pr = p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
      if (!pr.length) pr = p.variants.map(function (v) { return v.price; });
      p._low = pr.length ? Math.min.apply(null, pr) : 0;
    }
    Object.keys(prods).forEach(function (c) {
      prods[c].forEach(function (p, i) { prep(p, i); inCatalog[p.id] = true; });
    });
    swapList.forEach(prep);
    function kindOf(c) { var k = cats[c] && cats[c].kind; return k === 'carbon' || k === 'exhaust' ? k : 'addon'; }
    function isCarbon(c) { return kindOf(c) === 'carbon'; }
    stages.forEach(function (s) {
      (s.categories || []).forEach(function (c) { if (cats[c] && isCarbon(c) && carbonOrder.indexOf(c) === -1) carbonOrder.push(c); });
    });

    var region = document.createElement('div');
    region.className = 'vb-sr';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    host.appendChild(region);
    function announce(msg) { region.textContent = ''; setTimeout(function () { region.textContent = msg; }, 30); }

    /* sel[category] is one of { pid, vid } (a product), { skip: true } or { swap: true, pid, vid } (an approved swap part in that slot). */
    var S = { view: 'vehicle', vehicle: null, stage: null, step: 0, sel: {}, extras: [], filter: {}, swapFor: null, addonsSeen: false, pick: {}, open: false, adding: false, error: '', msg: null, added: null };

    /* ---------- lookups ---------- */
    function vehicle() { return S.vehicle ? vById[S.vehicle] : null; }
    function stage() { return S.stage ? sById[S.stage] : null; }
    function mainCats(s) { return ((s && s.categories) || []).filter(function (c) { return cats[c]; }); }
    function findProduct(c, pid) {
      var list = prods[c] || [];
      for (var i = 0; i < list.length; i++) if (list[i].id === pid) return list[i];
      return null;
    }
    function findSwap(pid) {
      for (var i = 0; i < swapList.length; i++) if (swapList[i].id === pid) return swapList[i];
      return null;
    }
    function findVariant(p, vid) {
      for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === vid) return p.variants[i];
      return null;
    }
    function pool(c) {
      var v = S.vehicle;
      return (prods[c] || []).filter(function (p) { return p.fit.indexOf(v) !== -1; })
        .sort(function (a, b) { return ((b._avail ? 1 : 0) - (a._avail ? 1 : 0)) || (a._i - b._i); });
    }
    /* A part that can still be bought at the package discount: in stock and not excluded. */
    function fillable(c) { return pool(c).some(function (p) { return p._avail && !p.excluded; }); }
    function isExtra(c) { return S.extras.indexOf(c) !== -1 && mainCats(stage()).indexOf(c) === -1; }
    function stepCats() {
      var s = stage();
      if (!s) return [];
      var main = mainCats(s);
      /* An exhaust (or any non-carbon step) with nothing listed for this vehicle is left out instead of blocking the stage. */
      var steps = main.filter(function (c) { return isCarbon(c) || design || pool(c).length > 0; });
      S.extras.forEach(function (c) {
        if (cats[c] && isCarbon(c) && main.indexOf(c) === -1 && steps.indexOf(c) === -1) steps.push(c);
      });
      return steps;
    }
    function addonCats() {
      var s = stage();
      if (!s) return [];
      return (s.addons || []).filter(function (c) {
        return cats[c] && kindOf(c) === 'addon' && (design || pool(c).some(function (p) { return p._avail; }));
      });
    }
    function buildCats() { return stepCats().concat(addonCats()); }
    function extraCats() {
      var inStage = mainCats(stage());
      return carbonOrder.filter(function (c) { return inStage.indexOf(c) === -1 && S.extras.indexOf(c) === -1 && fillable(c); });
    }
    /* Every carbon part of a stage needs something in stock. Exhaust and add-ons never block a stage. */
    function missingFor(stageHandle) {
      var s = sById[stageHandle];
      return mainCats(s).filter(function (c) { return isCarbon(c) && !pool(c).some(function (p) { return p._avail; }); });
    }
    /* A stage with no carbon steps at all (still being set up in the admin) can never be completed, so it is treated as not available. */
    function blocked(stageHandle) {
      var s = sById[stageHandle];
      return !design && (!s || !mainCats(s).some(isCarbon) || missingFor(stageHandle).length > 0);
    }
    function canSkip(c) { return !isExtra(c) && kindOf(c) !== 'addon'; }
    function canSwap(c) { return !isExtra(c) && isCarbon(c); }
    function modeOf(c) {
      var r = S.sel[c];
      if (S.swapFor === c) return 'swap';
      if (r && r.skip) return 'skip';
      if (r && r.swap) return 'swap';
      return 'select';
    }
    function swapOk(p) { return p.fit.indexOf(S.vehicle) !== -1 && !p.excluded && p._avail && p._low >= swapMin && !inCatalog[p.id]; }
    /* Approved swap parts for this vehicle, minus anything already used as a swap in another slot. A swap part never duplicates a catalog product. */
    function swapCandidates(c) {
      var used = {};
      stepCats().forEach(function (k) { var r = S.sel[k]; if (r && r.swap && k !== c) used[r.pid] = true; });
      return swapList.filter(function (p) { return swapOk(p) && !used[p.id]; })
        .sort(function (a, b) { return ((b._avail ? 1 : 0) - (a._avail ? 1 : 0)) || (a._i - b._i); });
    }
    function inBuild(pid, except) {
      return buildCats().some(function (k) { var r = S.sel[k]; return k !== except && r && !r.skip && r.pid === pid; });
    }
    function currentVariant(c, p) {
      var vid = S.pick[c + ':' + p.id];
      var v = vid ? findVariant(p, vid) : null;
      if (v) return v;
      var sel = S.sel[c];
      if (sel && sel.pid === p.id) { v = findVariant(p, sel.vid); if (v) return v; }
      return p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    }
    function capMinor(c) {
      var cap = cats[c].ownCap;
      return cap === null || cap === undefined ? null : shopToMinor(cap);
    }
    function linesNow() {
      var out = [];
      buildCats().forEach(function (c) {
        var r = S.sel[c];
        if (!r || r.skip) return;
        var p = r.swap ? findSwap(r.pid) : findProduct(c, r.pid);
        var v = p && findVariant(p, r.vid);
        if (!p || !v) return;
        var role = r.swap ? 'swap' : kindOf(c);
        var own = role === 'exhaust' || role === 'addon';
        out.push({
          category: c, role: role, price: v.price, available: v.available, excluded: !!p.excluded,
          ownPercent: own && rate > 0 ? num(cats[c].ownPercent, 0) : 0,
          ownCap: own ? capMinor(c) : null,
          product: p, variant: v
        });
      });
      return out;
    }
    function calc() {
      var missing = stepCats().filter(function (c) { return !S.sel[c]; });
      var res = Core.compute({ tiers: tiers, show: showSavings, missing: missing }, linesNow());
      res.live = live; res.previewing = previewing;
      return res;
    }
    function nextIncomplete(from) {
      var cs = stepCats(), i;
      for (i = from + 1; i < cs.length; i++) if (!S.sel[cs[i]]) return i;
      for (i = 0; i < from; i++) if (!S.sel[cs[i]]) return i;
      return -1;
    }
    function firstIncomplete() {
      var cs = stepCats();
      for (var i = 0; i < cs.length; i++) if (!S.sel[cs[i]]) return i;
      return -1;
    }
    /* Where the shopper is on the savings ladder and what they could still reach with parts that are in stock. */
    function meterInfo(res) {
      var counted = {};
      res.lines.forEach(function (l) { if (l.counts) counted[l.category] = true; });
      var reach = res.counted + carbonOrder.filter(function (c) { return !counted[c] && fillable(c); }).length;
      return { prog: Core.progress(tiers, res.counted, reach), reach: reach, extras: extraCats() };
    }
    function savingsLine(res, info) {
      var p = info.prog;
      if (p.atTop) return 'Maximum savings unlocked: ' + fmtPct(p.percent) + ' OFF every eligible carbon part.';
      if (p.next) {
        var n = p.next.need;
        return 'Add ' + n + (res.counted > 0 ? ' more' : '') + ' eligible carbon part' + (n === 1 ? '' : 's') + ' to unlock ' + fmtPct(p.next.percent) + ' OFF.';
      }
      return 'This is the best saving available for your build right now.';
    }
    function savingsSentence() {
      if (!showSavings) return '';
      var res = calc(), info = meterInfo(res);
      return 'Your build savings: ' + fmtPct(info.prog.percent) + ' off. ' + savingsLine(res, info);
    }
    function offerText(c) {
      var pc = rate > 0 ? num(cats[c].ownPercent, 0) : 0;
      if (!showSavings || pc <= 0) return '';
      var cap = capMinor(c);
      return fmtPct(pc) + ' off' + (cap !== null ? ', up to ' + money(cap) + ' off' : '');
    }

    /* ---------- storage ---------- */
    function saveSel() { if (S.vehicle) writeLS(SEL_KEY + S.vehicle, JSON.stringify({ v: 2, sel: S.sel, extras: S.extras })); }
    function loadSel() {
      S.sel = {}; S.extras = [];
      if (!S.vehicle) return;
      var raw = {};
      try { raw = JSON.parse(readLS(SEL_KEY + S.vehicle) || '{}') || {}; } catch (e) { raw = {}; }
      var saved = raw.v === 2 ? (raw.sel || {}) : raw; /* the first version stored the map on its own */
      var dropped = [], seen = {};
      Object.keys(saved).forEach(function (c) {
        if (!cats[c]) return;
        var r = saved[c] || {};
        var k = kindOf(c);
        if (r.skip) { if (k !== 'addon') S.sel[c] = { skip: true }; return; }
        var p = r.swap ? findSwap(r.pid) : findProduct(c, r.pid);
        var v = p && findVariant(p, r.vid);
        var ok = p && v && v.available && p.fit.indexOf(S.vehicle) !== -1 && !seen[p.id] && (!r.swap || (k === 'carbon' && swapOk(p)));
        if (ok) { seen[p.id] = true; S.sel[c] = r.swap ? { swap: true, pid: p.id, vid: v.id } : { pid: p.id, vid: v.id }; }
        else dropped.push(cats[c].name);
      });
      (Array.isArray(raw.extras) ? raw.extras : []).forEach(function (c) {
        if (cats[c] && isCarbon(c) && carbonOrder.indexOf(c) !== -1 && S.extras.indexOf(c) === -1) S.extras.push(c);
      });
      if (dropped.length) {
        S.msg = { type: 'warn', text: 'A saved choice is no longer available and was removed: ' + dropped.join(', ') + '. Please choose again.' };
        saveSel();
      }
    }

    /* ---------- url ---------- */
    function urlFor() {
      var u = new URL(window.location.href);
      function setp(k, v) { if (v) u.searchParams.set(k, v); else u.searchParams.delete(k); }
      setp('vehicle', S.vehicle);
      setp('stage', S.stage);
      setp('step', S.view === 'review' ? 'review' : (S.view === 'addons' ? 'addons' : (S.view === 'step' ? stepCats()[S.step] : null)));
      return u.pathname + u.search + u.hash;
    }
    function pushUrl(replace) {
      try { (replace ? history.replaceState : history.pushState).call(history, { vb: 1 }, '', urlFor()); } catch (e) { /* history unavailable */ }
    }
    function fromUrl() {
      var q = new URL(window.location.href).searchParams;
      var v = q.get('vehicle'), s = q.get('stage'), st = q.get('step');
      if (!vById[v]) v = readLS(VEH_KEY);
      if (!vById[v]) v = null;
      if (!sById[s]) s = null;
      S.vehicle = v; S.stage = s; S.msg = null; S.swapFor = null;
      loadSel();
      if (!v) { S.view = 'vehicle'; return; }
      writeLS(VEH_KEY, v);
      if (s && blocked(s)) S.stage = s = null;
      if (!s) { S.view = 'stage'; return; }
      if (st === 'review' && firstIncomplete() < 0) { S.view = 'review'; return; }
      if (st === 'addons' && firstIncomplete() < 0 && addonCats().length) { S.view = 'addons'; S.addonsSeen = true; return; }
      var idx = stepCats().indexOf(st);
      if (idx < 0) idx = firstIncomplete();
      if (idx < 0) { S.view = 'review'; return; }
      S.step = idx; S.view = 'step';
    }

    function go(view, step, opts) {
      opts = opts || {};
      S.view = view;
      if (typeof step === 'number') S.step = step;
      S.open = false; S.error = ''; S.swapFor = null;
      if (!opts.keepMsg) S.msg = null;
      pushUrl(opts.replace);
      render({ focus: true, scroll: true });
    }
    function afterSteps() {
      if (addonCats().length && !S.addonsSeen) { S.addonsSeen = true; go('addons', null, { keepMsg: true }); }
      else go('review');
    }
    function advance(from) {
      var n = nextIncomplete(from);
      if (n !== -1) go('step', n, { keepMsg: true }); else afterSteps();
    }
    function refocus(sel) {
      var el = root.querySelector(sel);
      if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    }

    /* ---------- views ---------- */
    function flowHtml() {
      var cur = S.view === 'vehicle' ? 0 : S.view === 'stage' ? 1 : (S.view === 'step' || S.view === 'addons') ? 2 : 3;
      var items = T.flow.map(function (name, i) {
        var state = i < cur || S.view === 'added' ? 'is-done' : (i === cur ? 'is-current' : 'is-todo');
        var label = `<b>${pad(i + 1)}</b><span>${esc(name)}</span>`;
        var act = i === 0 ? 'change-vehicle' : (i === 1 ? 'change-stage' : 'to-build');
        var can = state === 'is-done' && S.view !== 'added' && (i === 0 || (i === 1 && S.vehicle) || (i === 2 && S.vehicle && S.stage && !blocked(S.stage)));
        var inner = can ? `<button type='button' data-act='${act}'>${label}</button>` : `<span class='vb-fl'${state === 'is-current' ? ` aria-current='step'` : ''}>${label}</span>`;
        return `<li class='${state}'>${inner}</li>`;
      }).join('');
      return `<ol class='vb-flow' aria-label='Build progress'>${items}</ol>`;
    }
    function ctxHtml() {
      var v = vehicle(), s = stage();
      var out = `<p class='vb-ctx'><span>Building for <b>${esc(v.name)}</b> <button type='button' class='vb-link' data-act='change-vehicle'>Change</button></span>`;
      if (s && S.view !== 'stage') out += `<span><b>Stage ${esc(s.number)} &middot; ${esc(s.name)}</b> <button type='button' class='vb-link' data-act='change-stage'>Change</button></span>`;
      return out + '</p>';
    }
    function msgHtml() {
      if (!S.msg) return '';
      return `<p class='vb-msg is-${esc(S.msg.type)}'>${esc(S.msg.text)}</p>`;
    }

    function vehicleView() {
      var cards = vehicles.map(function (v) {
        var code = v.code || v.name;
        return `<button type='button' class='vb-veh${S.vehicle === v.handle ? ' is-on' : ''}' data-act='pick-vehicle' data-v='${esc(v.handle)}'>` +
          (v.image ? `<img src='${esc(v.image)}' alt='' loading='lazy'>` : '') +
          `<span class='vb-veh-code' aria-hidden='true'>${esc(code)}</span>` +
          `<span class='vb-veh-b'><b>${esc(v.name)}</b><span class='vb-btn vb-btn--sm'>${T.chooseVehicle}</span></span></button>`;
      }).join('');
      return `<section aria-labelledby='vb-h'><header class='vb-step-h'><h2 id='vb-h' tabindex='-1' data-focus>${T.vehicleH}</h2><p class='vt-m'>${T.vehicleP}</p></header>` +
        (cards ? `<div class='vb-vehs'>${cards}</div>` : `<p class='vb-empty'>${T.noVehicles}</p>`) + '</section>';
    }

    function stageCard(s) {
      var miss = missingFor(s.handle);
      var isBlocked = blocked(s.handle);
      var sc = mainCats(s);
      var carbonN = sc.filter(isCarbon).length;
      var pct = Core.tierFor(tiers, carbonN).percent;
      var saving = '';
      if (showSavings && pct > 0) {
        var what = sc.length > carbonN ? 'the carbon parts' : 'the package';
        saving = live ? `<span class='vb-stg-save'>Save ${fmtPct(pct)} on ${what}</span>` : `<span class='vb-stg-save is-draft'>Preview: ${fmtPct(pct)} off ${what} (not live yet)</span>`;
      }
      var chips = sc.map(function (c) { return `<li class='vb-chip'>${esc(cats[c].name)}</li>`; }).join('');
      var btn = isBlocked
        ? `<button type='button' class='vb-btn' disabled>Not available for this vehicle yet</button>`
        : `<button type='button' class='vb-btn vb-btn--ac' data-act='pick-stage' data-s='${esc(s.handle)}'>${T.chooseStage}</button>`;
      var why = (design && miss.length) ? `<p class='vb-hint'>Admin: no in-stock ${esc(vehicle().name)} product for ${miss.map(function (c) { return esc(cats[c] ? cats[c].name : c); }).join(', ')}.</p>` : '';
      return `<article class='vb-stg${S.stage === s.handle ? ' is-on' : ''}${isBlocked ? ' is-blocked' : ''}'>` +
        `<div class='vb-stg-img'>${s.image ? `<img src='${esc(s.image)}' alt='' loading='lazy'>` : ''}<span class='vb-stg-n' aria-hidden='true'>${esc(s.number)}</span></div>` +
        `<div class='vb-stg-b'><span class='vt-e'>Stage ${esc(s.number)}</span><h3>${esc(s.name)}</h3>` +
        (s.summary ? `<p class='vt-m'>${esc(s.summary)}</p>` : '') +
        `<ul class='vb-chips'>${chips}</ul>${why}` +
        `<div class='vb-stg-f'><div>${saving}<span class='vb-meta'>${plural(sc.length, 'step', 'steps')}${carbonN ? ' &middot; skip or swap' : ''}</span></div>${btn}</div></div></article>`;
    }
    function stageView() {
      return `<section aria-labelledby='vb-h'><header class='vb-step-h'><h2 id='vb-h' tabindex='-1' data-focus>${T.stageH}</h2><p class='vt-m'>${T.stageP}</p></header>` +
        `<div class='vb-stgs'>${stages.length ? stages.map(stageCard).join('') : `<p class='vb-empty'>No stages are set up yet.</p>`}</div></section>`;
    }

    /* mode: 'select' (catalog product), 'swap' (approved swap part) or 'addon' (optional extra, toggles) */
    function cardHtml(c, p, mode) {
      mode = mode || 'select';
      var sel = S.sel[c];
      var isSel = !!(sel && !sel.skip && sel.pid === p.id && (mode === 'swap' ? sel.swap : !sel.swap));
      var v = currentVariant(c, p);
      var same = isSel && sel.vid === v.id;
      var prices = p.variants.map(function (x) { return x.price; });
      var varies = Math.min.apply(null, prices) !== Math.max.apply(null, prices);
      var img = v.image || (p.image && p.image.src) || '';
      var act = mode === 'swap' ? 'choose-swap' : (mode === 'addon' ? 'choose-addon' : 'choose');
      var words = mode === 'swap' ? ['Swap in', 'Swapped in', 'Update swap'] : (mode === 'addon' ? ['Add', 'Added', 'Update'] : [T.select, T.selected, T.update]);
      var select = '';
      if (!p.single && p.variants.length > 1) {
        select = `<label class='vb-var'><span class='vb-sr'>Option for ${esc(p.title)}</span><select data-cat='${esc(c)}' data-pid='${p.id}' data-mode='${mode}'${p._avail ? '' : ' disabled'}>` +
          p.variants.map(function (x) {
            return `<option value='${x.id}'${x.id === v.id ? ' selected' : ''}${x.available ? '' : ' disabled'}>` +
              esc(x.title + (varies ? ' · ' + money(x.price) : '') + (x.available ? '' : ' · Sold out')) + '</option>';
          }).join('') + '</select></label>';
      }
      var low = (v.tracked && v.policy === 'deny' && v.qty > 0 && v.qty <= 3) ? `<p class='vb-low'>Only ${v.qty} left</p>` : '';
      var fine = (showSavings && p.excluded && mode !== 'addon') ? `<span class='vb-fine'>Not included in package savings</span>` : '';
      var btn;
      if (!p._avail) btn = `<button type='button' class='vb-btn' disabled>${T.soldOut}</button>`;
      else if (!v.available) btn = `<button type='button' class='vb-btn' disabled>${T.optionSoldOut}</button>`;
      else if (same) btn = `<button type='button' class='vb-btn vb-btn--sel' data-act='${act}' data-cat='${esc(c)}' data-pid='${p.id}' aria-pressed='true'>${words[1]} &#10003;${mode === 'addon' ? `<span class='vb-sr'> (select again to remove)</span>` : ''}</button>`;
      else btn = `<button type='button' class='vb-btn' data-act='${act}' data-cat='${esc(c)}' data-pid='${p.id}'>${isSel ? words[2] : words[0]}<span class='vb-sr'> ${esc(p.title)}</span></button>`;
      return `<article class='vb-card${isSel ? ' is-sel' : ''}${p._avail ? '' : ' is-out'}' data-card='${p.id}'>` +
        `<div class='vb-card-img'>${img ? `<img src='${esc(img)}' alt='${esc(p.image && p.image.alt || p.title)}' loading='lazy'>` : ''}${isSel ? `<span class='vb-tag'>${words[1]}</span>` : ''}</div>` +
        `<div class='vb-card-b'>${p.exType ? `<span class='vb-type'>${esc(p.exType)}</span>` : ''}<h3 class='vb-card-t'>${esc(p.title)}</h3>` +
        `<p class='vb-price'><span class='vb-now'>${money(v.price)}</span>${v.compareAt ? ` <s class='vb-was'>${money(v.compareAt)}</s>` : ''}</p>` +
        select + fine + low + btn +
        `<a class='vb-det' href='${esc(p.url)}' target='_blank' rel='noopener' aria-label='Details for ${esc(p.title)} (opens in a new tab)'>Details</a></div></article>`;
    }

    function emptyHtml(c) {
      var cat = cats[c], v = vehicle();
      return `<div class='vb-empty'><p>There is no ${esc(cat.name.toLowerCase())} listed for ${esc(v.name)} yet.</p><p class='vt-m'>You can skip this part or choose a different stage.</p>` +
        `<div class='vb-row'>${canSkip(c) ? `<button type='button' class='vb-btn' data-act='skip' data-cat='${esc(c)}'>Skip this part</button>` : ''}<button type='button' class='vb-btn vb-btn--ac' data-act='change-stage'>Choose another stage</button></div></div>`;
    }
    function soldOutHtml(c) {
      return `<p class='vb-msg is-warn' role='status'>Every ${esc(cats[c].name.toLowerCase())} listed for ${esc(vehicle().name)} is sold out right now. ${canSkip(c) ? `You can skip this part or ` : 'You can '}<button type='button' class='vb-link' data-act='change-stage'>choose another stage</button>.</p>`;
    }
    function debugHtml(c) {
      var cat = cats[c], v = vehicle();
      var comp = pool(c);
      return `<details class='vb-debug'><summary>Admin check (only visible in the theme editor)</summary><ul>` +
        `<li>Category collection: ${cat.collection ? `linked and published (${esc(cat.collectionTitle)}, ${cat.total} products)` : `<b>not found. Link a collection to this category and publish it to the Online Store.</b>`}</li>` +
        `<li>Products read from it that have vehicle fitment set: ${(prods[c] || []).length}${cat.total > 50 ? ' (only the first 50 products of a collection are read)' : ''}</li>` +
        `<li>Fit ${esc(v.name)}: ${comp.length}, in stock: ${comp.filter(function (p) { return p._avail; }).length}</li>` +
        (isCarbon(c) ? `<li>Approved swap parts that fit ${esc(v.name)}: ${swapCandidates(c).length} (collection: Approved Swap Parts, minimum price ${money(swapMin)})</li>` : '') + '</ul></details>';
    }

    function actHtml(c) {
      var mode = modeOf(c), swap = canSwap(c);
      function b(act, label, on) {
        return `<button type='button' class='vb-acb' data-act='${act}' data-cat='${esc(c)}' aria-pressed='${on ? 'true' : 'false'}'>${label}</button>`;
      }
      var hint = swap ? 'Already own it? Skip it, or swap it for another approved carbon part.' : 'Already have one? You can skip this step.';
      return `<div class='vb-act'><div class='vb-act-g' role='group' aria-label='How do you want to handle ${esc(cats[c].name)}?'>` +
        b('mode-select', 'Select', mode === 'select') + b('skip', 'Skip', mode === 'skip') + (swap ? b('mode-swap', 'Swap', mode === 'swap') : '') +
        `</div><span class='vb-act-l'>${hint}</span></div>`;
    }
    function typesFor(list) {
      var seen = [];
      list.forEach(function (p) { if (p.exType && seen.indexOf(p.exType) === -1) seen.push(p.exType); });
      return seen.sort(function (a, b) {
        var ia = EXHAUST_ORDER.indexOf(a), ib = EXHAUST_ORDER.indexOf(b);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
    }
    function selectBody(c) {
      var list = pool(c);
      var types = kindOf(c) === 'exhaust' ? typesFor(list) : [];
      var f = S.filter[c] || '';
      if (f && types.indexOf(f) === -1) f = '';
      var shown = f ? list.filter(function (p) { return p.exType === f; }) : list;
      var chips = '';
      if (types.length > 1) {
        chips = `<div class='vb-filt' role='group' aria-label='Exhaust type'>` +
          [''].concat(types).map(function (t) {
            return `<button type='button' class='vb-fchip' data-act='filter' data-cat='${esc(c)}' data-v='${esc(t)}' aria-pressed='${t === f ? 'true' : 'false'}'>${esc(t || 'All')}</button>`;
          }).join('') + '</div>';
      }
      if (!list.length) return emptyHtml(c);
      return (list.some(function (p) { return p._avail; }) ? '' : soldOutHtml(c)) + chips +
        `<div class='vb-cards'>${shown.map(function (p) { return cardHtml(c, p, 'select'); }).join('')}</div>`;
    }
    function skipBody(c) {
      var cat = cats[c];
      var swapHint = (canSwap(c) && swapCandidates(c).length) ? ` Swap it for another approved carbon part to keep a part counting toward your savings.` : '';
      return `<div class='vb-state is-skip'><span class='vb-state-t'>${esc(cat.name)} skipped</span>` +
        `<span class='vb-state-d'>It will not be added to your cart${showSavings && isCarbon(c) ? ' and does not count toward your savings' : ''}.${swapHint}</span>` +
        `<div class='vb-row'><button type='button' class='vb-btn vb-btn--sm' data-act='mode-select' data-cat='${esc(c)}'>Choose a product</button>` +
        (canSwap(c) ? `<button type='button' class='vb-btn vb-btn--sm vb-btn--ghost' data-act='mode-swap' data-cat='${esc(c)}'>Swap instead</button>` : '') + '</div></div>';
    }
    function swapBody(c) {
      var cat = cats[c], v = vehicle();
      var cands = swapCandidates(c);
      var intro = `<div class='vb-state'><span class='vb-state-t'>Swap ${esc(cat.name)}</span>` +
        `<span class='vb-state-d'>Replace it with another approved carbon part for ${esc(v.name)}. A swap counts once toward your savings, in place of ${esc(cat.name.toLowerCase())}.</span></div>`;
      if (!cands.length) {
        return intro + `<div class='vb-empty'><p>No approved swap parts are listed for ${esc(v.name)} yet.</p><p class='vt-m'>You can choose a ${esc(cat.name.toLowerCase())} instead, or skip this part.</p>` +
          `<div class='vb-row'><button type='button' class='vb-btn vb-btn--ac' data-act='mode-select' data-cat='${esc(c)}'>Choose a product</button><button type='button' class='vb-btn' data-act='skip' data-cat='${esc(c)}'>Skip this part</button></div></div>`;
      }
      return intro + `<div class='vb-cards'>${cands.map(function (p) { return cardHtml(c, p, 'swap'); }).join('')}</div>`;
    }
    function stepView() {
      var cs = stepCats(), c = cs[S.step], cat = cats[c], v = vehicle();
      var mode = modeOf(c), extra = isExtra(c), kind = kindOf(c);
      var res = calc();
      var head = `<header class='vb-step-h'><span class='vt-e'>${T.stepOf.replace('{n}', pad(S.step + 1)).replace('{total}', pad(cs.length))}${extra ? ` <span class='vb-x'>Extra</span>` : ''}</span>` +
        `<h2 id='vb-h' tabindex='-1' data-focus>${esc(cat.name)}</h2>` +
        `<p class='vt-m'>${esc(cat.helper || T.stepP.replace('{category}', cat.name.toLowerCase()).replace('{vehicle}', v.name))}</p></header>`;
      var extraNote = extra ? `<div class='vb-state'><span class='vb-state-t'>Extra part</span><span class='vb-state-d'>This part is from outside your stage. It counts toward your savings.</span><div class='vb-row'><button type='button' class='vb-btn vb-btn--sm vb-btn--ghost' data-act='remove' data-cat='${esc(c)}'>Remove from build</button></div></div>` : '';
      var offer = '';
      if (kind === 'exhaust') {
        var ot = offerText(c);
        offer = ot ? `<span class='vb-offer'>Exhaust offer: ${esc(ot)}.</span>` : (showSavings ? `<span class='vb-fine' style='margin:0 0 20px'>Exhaust is priced separately and does not count toward your carbon savings.</span>` : '');
      }
      var body = mode === 'skip' ? skipBody(c) : (mode === 'swap' ? swapBody(c) : selectBody(c));
      var sel = S.sel[c];
      var foot = `<footer class='vb-step-f'>` +
        (S.step > 0 ? `<button type='button' class='vb-btn vb-btn--ghost' data-act='prev'>&larr; ${T.back}</button>` : `<button type='button' class='vb-btn vb-btn--ghost' data-act='change-stage'>&larr; ${T.stages}</button>`) +
        (sel ? `<button type='button' class='vb-btn vb-btn--ac' data-act='next'>${T.next} &rarr;</button>` : '') + '</footer>';
      return `<section class='vb-step' aria-labelledby='vb-h'>${head}${meterHtml(res, 'm')}${extraNote}${(canSkip(c) || canSwap(c)) ? actHtml(c) : ''}${offer}${body}${foot}${design ? debugHtml(c) : ''}</section>`;
    }

    function addonsView() {
      var res = calc(), cs = addonCats();
      var secs = cs.map(function (c) {
        var ot = offerText(c);
        return `<section class='vb-addsec' aria-labelledby='vb-as-${esc(c)}'><div class='vb-addsec-h'><h3 class='vb-addsec-t' id='vb-as-${esc(c)}'>${esc(cats[c].name)}</h3>${ot ? `<span class='vb-fine'>Offer: ${esc(ot)}</span>` : ''}</div>` +
          `<div class='vb-cards'>${pool(c).map(function (p) { return cardHtml(c, p, 'addon'); }).join('')}</div></section>`;
      }).join('');
      var chosen = cs.filter(function (c) { return S.sel[c]; }).length;
      return `<section class='vb-step' aria-labelledby='vb-h'><header class='vb-step-h'><span class='vt-e'>Optional</span><h2 id='vb-h' tabindex='-1' data-focus>${T.addonsH}</h2><p class='vt-m'>${T.addonsP}</p></header>` +
        `${meterHtml(res, 'm')}${secs || `<p class='vb-empty'>There are no add-ons listed for this vehicle yet.</p>`}` +
        `<footer class='vb-step-f'><button type='button' class='vb-btn vb-btn--ghost' data-act='prev'>&larr; ${T.back}</button>` +
        `<button type='button' class='vb-btn vb-btn--ac' data-act='review'${res.complete ? '' : ' disabled'}>${chosen ? 'Continue to review' : 'Skip add-ons'} &rarr;</button></footer></section>`;
    }

    /* ---------- savings meter ---------- */
    function meterHtml(res, where) {
      if (!showSavings) return '';
      var info = meterInfo(res), p = info.prog, n = topParts || 1;
      var segs = '';
      for (var i = 1; i <= n; i++) segs += i <= res.counted ? `<i class='is-on'></i>` : '<i></i>';
      var labels = '', prev = 0;
      tiers.forEach(function (t) {
        if (t.percent > prev && t.parts <= n) labels += `<li style='grid-column:${t.parts}'${res.counted >= t.parts ? ` class='is-on'` : ''}>${fmtPct(t.percent)}</li>`;
        prev = t.percent;
      });
      var more = '';
      if (info.extras.length && !p.atTop) {
        more = `<div class='vb-sv-x'><span class='vb-sv-xl'>Add another carbon part</span>` +
          info.extras.map(function (c) { return `<button type='button' class='vb-xchip' data-act='add-extra' data-cat='${esc(c)}'>+ ${esc(cats[c].name)}</button>`; }).join('') + '</div>';
      }
      return `<section class='vb-sv vb-sv--${where}' aria-label='Your build savings'>` +
        `<div class='vb-sv-h'><span class='vb-sv-e'>Your build savings${previewing ? ` <span class='vb-tg is-pre'>Preview</span>` : ''}</span><span class='vb-sv-p${p.percent > 0 ? '' : ' is-zero'}'>${fmtPct(p.percent)} OFF</span></div>` +
        `<div class='vb-sv-bar' style='--n:${n}' role='img' aria-label='${esc(res.counted + ' of ' + n + ' eligible carbon parts, ' + fmtPct(p.percent) + ' off')}'>${segs}</div>` +
        `<ol class='vb-sv-tiers' style='--n:${n}' aria-hidden='true'>${labels}</ol>` +
        `<span class='vb-sv-m'>${esc(savingsLine(res, info))}</span>${more}</section>`;
    }

    function totalsHtml(res) {
      var rows = `<div><dt>Individual products total</dt><dd>${money(res.individual)}</dd></div>`;
      if (showSavings) {
        if (res.carbonDiscount > 0) rows += `<div class='vb-disc'><dt>Package discount (${fmtPct(res.percent)})</dt><dd>&minus;${money(res.carbonDiscount)}</dd></div>`;
        else rows += `<div class='vb-disc is-off'><dt>Package discount</dt><dd>Not unlocked yet</dd></div>`;
        if (res.ownDiscount > 0) {
          var exh = res.lines.some(function (l) { return l.kind === 'own' && l.role === 'exhaust'; });
          rows += `<div class='vb-disc'><dt>${exh ? 'Exhaust offer' : 'Add-on offer'}</dt><dd>&minus;${money(res.ownDiscount)}</dd></div>`;
        }
        rows += `<div class='vb-saved${res.discount > 0 ? '' : ' is-off'}'><dt>Amount saved</dt><dd>${money(res.discount)}</dd></div>`;
      }
      rows += `<div class='vb-final'><dt>${showSavings ? 'Package total' : 'Total'}</dt><dd>${money(res.total)}</dd></div>`;
      return `<dl class='vb-tot'>${rows}</dl>${noteHtml(res)}`;
    }
    function noteHtml(res) {
      var n = res.missing.length, out = '';
      if (res.previewing) out += `<p class='vb-note is-draft'>Preview only. These savings are not live yet, so your store charges the individual total.</p>`;
      if (!res.complete) out += `<p class='vb-note'>Select, skip or swap ${plural(n, 'more step', 'more steps')} to review your build.</p>`;
      else if (!res.purchasable && res.lines.length === 0) out += `<p class='vb-note'>You have skipped every part, so there is nothing to add to your cart yet.</p>`;
      else if (!res.purchasable) out += `<p class='vb-note'>One of your choices is sold out, so the package cannot be added yet.</p>`;
      if (showSavings) {
        var ex = res.lines.filter(function (l) { return l.excluded; }).map(function (l) { return cats[l.category].name; });
        if (ex.length) out += `<p class='vb-note'>Not included in package savings: ${ex.map(esc).join(', ')}.</p>`;
        if (res.lines.some(function (l) { return (l.role === 'exhaust' || l.role === 'addon') && l.kind !== 'own'; })) out += `<p class='vb-note'>Exhaust and add-ons are priced separately and do not count toward your carbon savings.</p>`;
        if (res.live && res.discount > 0 && res.purchasable) out += `<p class='vb-note'>Your discount is applied at checkout.</p>`;
      }
      return out;
    }
    function ctaHtml(res, cls) {
      var n = res.missing.length, short = cls === 'vb-cta-m';
      if (S.view === 'review') {
        var dis = !res.purchasable || S.adding;
        return `<button type='button' class='vb-btn vb-btn--ac vb-cta ${cls}' data-act='add'${short ? ` aria-label='${T.add}'` : ''}${dis ? ' disabled' : ''}>${S.adding ? T.adding : (short ? T.addShort : T.add)}</button>`;
      }
      return `<button type='button' class='vb-btn vb-btn--ac vb-cta ${cls}' data-act='review'${res.complete ? '' : ' disabled'}${short && !res.complete ? ` aria-label='${plural(n, 'step', 'steps')} left to continue'` : ''}>` +
        (res.complete ? T.review : (short ? n + ' left' : plural(n, 'step', 'steps') + ' left')) + '</button>';
    }

    function trackerHtml() {
      var s = stage(), v = vehicle(), cs = stepCats(), ac = addonCats();
      var res = calc();
      var byCat = {};
      linesNow().forEach(function (l) { byCat[l.category] = l; });
      var done = cs.filter(function (c) { return S.sel[c]; }).length;
      var rows = cs.map(function (c, i) {
        var l = byCat[c], r = S.sel[c];
        var skipped = !!(r && r.skip);
        var cur = S.view === 'step' && S.step === i;
        var state = l ? 'is-done' : (skipped ? 'is-skip' : 'is-todo');
        var removable = !!l || isExtra(c);
        var thumb = l ? (l.variant.image || (l.product.image && l.product.image.src) || '') : '';
        var tag = l ? (l.role === 'swap' ? `<span class='vb-tg'>Swap</span>` : (isExtra(c) ? `<span class='vb-tg'>Extra</span>` : '')) : (skipped ? `<span class='vb-tg is-skip'>Skipped</span>` : '');
        var detail = l ? `<span class='vb-st-p'>${tag}${esc(l.product.title)}</span>${l.product.single ? '' : `<span class='vb-st-v'>${esc(l.variant.title)}</span>`}` : (skipped ? `<span class='vb-st-v'>Not added to your cart</span>` : `<span class='vb-st-v'>Not selected yet</span>`);
        var label = cats[c].name + (l ? ': ' + (l.role === 'swap' ? 'swapped for ' : '') + l.product.title + (l.product.single ? '' : ', ' + l.variant.title) + ', ' + money(l.variant.price) + '. Change' : (skipped ? ': skipped. Change' : ': not selected. Choose'));
        return `<li class='vb-st ${state}${cur ? ' is-current' : ''}${removable ? ' has-x' : ''}'><button type='button' class='vb-st-b' data-act='goto' data-i='${i}'${cur ? ` aria-current='step'` : ''} aria-label='${esc(label)}'>` +
          `<span class='vb-st-n'>${l ? '&#10003;' : (skipped ? '&ndash;' : i + 1)}</span>` +
          `<span class='vb-st-thumb'>${thumb ? `<img src='${esc(thumb)}' alt=''>` : ''}</span>` +
          `<span class='vb-st-t'><b>${esc(cats[c].name)}</b>${detail}</span>` +
          `<span class='vb-st-c'>${l ? `<span class='vb-st-pr'>${money(l.variant.price)}</span>` : ''}<span class='vb-st-ch'>${l || skipped ? 'Change' : (cur ? 'Now' : 'Select')}</span></span></button>` +
          (removable ? `<button type='button' class='vb-st-x' data-act='remove' data-cat='${esc(c)}' aria-label='Remove ${esc(cats[c].name)} from your build'><span aria-hidden='true'>&times;</span></button>` : '') + '</li>';
      }).join('');
      var addRows = ac.filter(function (c) { return byCat[c]; }).map(function (c) {
        var l = byCat[c];
        var thumb = l.variant.image || (l.product.image && l.product.image.src) || '';
        return `<li class='vb-st is-done has-x'><button type='button' class='vb-st-b' data-act='to-addons' aria-label='${esc(cats[c].name + ': ' + l.product.title + ', ' + money(l.variant.price) + '. Change')}'>` +
          `<span class='vb-st-n'>+</span><span class='vb-st-thumb'>${thumb ? `<img src='${esc(thumb)}' alt=''>` : ''}</span>` +
          `<span class='vb-st-t'><b>${esc(cats[c].name)}</b><span class='vb-st-p'>${esc(l.product.title)}</span></span>` +
          `<span class='vb-st-c'><span class='vb-st-pr'>${money(l.variant.price)}</span><span class='vb-st-ch'>Change</span></span></button>` +
          `<button type='button' class='vb-st-x' data-act='remove' data-cat='${esc(c)}' aria-label='Remove ${esc(cats[c].name)} from your build'><span aria-hidden='true'>&times;</span></button></li>`;
      }).join('');
      var addBlock = ac.length ? `<div class='vb-trk-add'><div class='vb-trk-addh'><span>Add-ons<small>Optional</small></span><button type='button' class='vb-link' data-act='to-addons'>${addRows ? 'Change' : 'Browse'}</button></div>` +
        (addRows ? `<ol class='vb-trk-sub'>${addRows}</ol>` : `<span class='vb-trk-none'>None selected</span>`) + '</div>' : '';
      var barSav = showSavings ? `<span class='vb-bar-s${previewing ? ' is-pre' : ''}'>&middot; ${fmtPct(res.percent)} off</span>` : '';
      return `<aside class='vb-side${S.open ? ' is-open' : ''}' aria-label='Your build'>` +
        `<div class='vb-bar'><button type='button' class='vb-bar-t' data-act='toggle-sheet' aria-expanded='${S.open ? 'true' : 'false'}' aria-controls='vb-panel'>` +
        `<span class='vb-bar-n'>${done}/${cs.length}</span><span class='vb-bar-l'><span class='vb-bar-k'>Your build ${barSav}</span><span class='vb-bar-p'>${money(res.total)}</span></span><span class='vb-chev' aria-hidden='true'></span></button>` +
        `${ctaHtml(res, 'vb-cta-m')}</div>` +
        `<div class='vb-panel' id='vb-panel'><section class='vb-trk'>` +
        `<header class='vb-trk-h'><span class='vt-e'>Your build</span><h2>Stage ${esc(s.number)} &middot; ${esc(s.name)}</h2>` +
        `<p class='vt-m'>${esc(v.name)} <button type='button' class='vb-link' data-act='change-vehicle'>Change</button></p>` +
        `<div class='vb-prog' role='progressbar' aria-valuemin='0' aria-valuemax='${cs.length}' aria-valuenow='${done}' aria-label='Steps done'><span style='width:${cs.length ? Math.round(done / cs.length * 100) : 0}%'></span></div>` +
        `<p class='vb-prog-t'>${done} of ${cs.length} done</p></header>` +
        `${meterHtml(res, 't')}<ol class='vb-trk-list'>${rows}</ol>${addBlock}` +
        `${totalsHtml(res)}${ctaHtml(res, 'vb-cta-d')}</section></div></aside>`;
    }

    function reviewRow(c, i, l, pc, res) {
      var cat = cats[c], r = S.sel[c];
      if (!l && r && r.skip) {
        return `<li class='vb-rv is-missing is-skip'><span class='vb-rv-n'>${pad(i + 1)}</span><div class='vb-rv-t'><span class='vb-meta'>${esc(cat.name)} <span class='vb-tg is-skip'>Skipped</span></span><span class='vt-m'>Not added to your cart</span></div><button type='button' class='vb-btn vb-btn--sm' data-act='goto' data-i='${i}'>Change</button></li>`;
      }
      if (!l) return `<li class='vb-rv is-missing'><span class='vb-rv-n'>${pad(i + 1)}</span><div class='vb-rv-t'><b>${esc(cat.name)}</b><span class='vt-m'>Not selected yet</span></div><button type='button' class='vb-btn vb-btn--sm vb-btn--ac' data-act='goto' data-i='${i}'>Choose</button></li>`;
      var thumb = l.variant.image || (l.product.image && l.product.image.src) || '';
      var price;
      if (pc && pc.discount > 0) price = `<s class='vb-was'>${money(pc.price)}</s> <b>${money(pc.final)}</b> <span class='vb-off'>&minus;${fmtPct(pc.percent)}</span>`;
      else {
        var why = '';
        if (showSavings && pc) {
          if (pc.excluded) why = ` <span class='vb-off is-none'>Not in package savings</span>`;
          else if (pc.role === 'carbon' || pc.role === 'swap') why = ` <span class='vb-off is-none'>No discount yet</span>`;
        }
        price = `<b>${money(l.variant.price)}</b>${why}`;
      }
      var tag = l.role === 'swap' ? ` <span class='vb-tg'>Swapped in</span>` : (isExtra(c) ? ` <span class='vb-tg'>Extra</span>` : '');
      return `<li class='vb-rv${l.available ? '' : ' is-out'}'><span class='vb-rv-n'>${pad(i + 1)}</span><span class='vb-rv-img'>${thumb ? `<img src='${esc(thumb)}' alt=''>` : ''}</span>` +
        `<div class='vb-rv-t'><span class='vb-meta'>${esc(cat.name)}${tag}</span><b>${esc(l.product.title)}</b>${l.product.single ? '' : `<span class='vt-m'>${esc(l.variant.title)}</span>`}${l.available ? '' : `<span class='vb-low'>Sold out</span>`}</div>` +
        `<div class='vb-rv-p'>${price}</div><button type='button' class='vb-link' data-act='goto' data-i='${i}'>Change</button></li>`;
    }
    function reviewView() {
      var res = calc(), cs = stepCats(), s = stage(), ac = addonCats();
      var byCat = {}, pl = {};
      linesNow().forEach(function (l) { byCat[l.category] = l; });
      res.lines.forEach(function (l) { pl[l.category] = l; });
      var rows = cs.map(function (c, i) { return reviewRow(c, i, byCat[c], pl[c], res); }).join('');
      var addRows = ac.filter(function (c) { return byCat[c]; }).map(function (c) {
        var l = byCat[c], pc = pl[c];
        var thumb = l.variant.image || (l.product.image && l.product.image.src) || '';
        var price = (pc && pc.discount > 0) ? `<s class='vb-was'>${money(pc.price)}</s> <b>${money(pc.final)}</b> <span class='vb-off'>&minus;${fmtPct(pc.percent)}</span>` : `<b>${money(l.variant.price)}</b>`;
        return `<li class='vb-rv${l.available ? '' : ' is-out'}'><span class='vb-rv-n'>+</span><span class='vb-rv-img'>${thumb ? `<img src='${esc(thumb)}' alt=''>` : ''}</span>` +
          `<div class='vb-rv-t'><span class='vb-meta'>${esc(cats[c].name)} <span class='vb-tg'>Add-on</span></span><b>${esc(l.product.title)}</b>${l.product.single ? '' : `<span class='vt-m'>${esc(l.variant.title)}</span>`}${l.available ? '' : `<span class='vb-low'>Sold out</span>`}</div>` +
          `<div class='vb-rv-p'>${price}</div><button type='button' class='vb-link' data-act='to-addons'>Change</button></li>`;
      }).join('');
      var addNote = (ac.length && !addRows) ? `<li class='vb-rvg'>No add-ons selected. <button type='button' class='vb-link' data-act='to-addons'>Browse add-ons</button></li>` : (addRows ? `<li class='vb-rvg'>Optional add-ons</li>${addRows}` : '');
      var warn = '';
      if (!res.complete) warn = `<p class='vb-msg is-warn'>Your build is not complete yet. Choose, skip or swap: ${res.missing.map(function (c) { return esc(cats[c].name); }).join(', ')}.</p>`;
      else if (!res.purchasable && res.lines.length === 0) warn = `<p class='vb-msg is-warn'>You have skipped every part, so there is nothing to add to your cart. Change a step to continue.</p>`;
      else if (!res.purchasable) warn = `<p class='vb-msg is-warn'>Some choices are sold out: ${res.unavailable.map(function (c) { return esc(cats[c].name); }).join(', ')}. Change them to continue.</p>`;
      var err = S.error ? `<p class='vb-msg is-err' role='alert' data-focus tabindex='-1'>${esc(S.error)}</p>` : '';
      return `<section aria-labelledby='vb-h'><header class='vb-step-h'><span class='vt-e'>Stage ${esc(s.number)} &middot; ${esc(s.name)}</span><h2 id='vb-h' tabindex='-1'${S.error ? '' : ' data-focus'}>${T.reviewH}</h2><p class='vt-m'>${T.reviewP}</p></header>` +
        `${warn}${err}${meterHtml(res, 'm')}<ol class='vb-rvs'>${rows}${addNote}</ol>` +
        `<footer class='vb-step-f'><button type='button' class='vb-btn vb-btn--ghost' data-act='prev'>&larr; ${T.back}</button>${ctaHtml(res, '')}</footer></section>`;
    }

    function addedView() {
      var a = S.added || {};
      return `<section class='vb-done' aria-labelledby='vb-h'><span class='vt-e'>Stage ${esc(a.number)} &middot; ${esc(a.stageName)}</span>` +
        `<h2 id='vb-h' tabindex='-1' data-focus>${T.doneH}</h2>` +
        `<p class='vt-m'>${a.count} ${a.count === 1 ? 'item' : 'items'} for ${esc(a.vehicleName)} (individual total ${money(a.individual)}).<span data-applied>${a.applied ? ' ' + esc(a.applied) : ''}</span></p>` +
        `<div class='vb-row'><a class='vb-btn' href='${esc(routes.cart || '/cart')}'>${T.viewCart}</a><a class='vb-btn vb-btn--ac' href='${esc(routes.checkout || '/checkout')}'>${T.checkout}</a><button type='button' class='vb-btn vb-btn--ghost' data-act='again'>${T.buildAnother}</button></div></section>`;
    }

    /* ---------- render ---------- */
    function render(opts) {
      opts = opts || {};
      var v = vehicle(), s = stage();
      if (S.view === 'step' && !stepCats()[S.step]) {
        if (stepCats().length) S.step = stepCats().length - 1; else S.view = s ? 'stage' : 'vehicle';
      }
      var main;
      if (S.view === 'vehicle') main = vehicleView();
      else if (S.view === 'stage') main = stageView();
      else if (S.view === 'step') main = stepView();
      else if (S.view === 'addons') main = addonsView();
      else if (S.view === 'review') main = reviewView();
      else main = addedView();
      var withTrk = (S.view === 'step' || S.view === 'review' || S.view === 'addons') && v && s;
      var html = flowHtml() + (v && S.view !== 'vehicle' && S.view !== 'added' ? ctxHtml() : '') + msgHtml() +
        `<div class='vb-grid${withTrk ? ' vb-grid--trk' : ''}'><div class='vb-main'>${main}</div>${withTrk ? trackerHtml() : ''}</div>`;
      root.innerHTML = html;
      root.classList.toggle('has-trk', !!withTrk);
      if (opts.focus) {
        var f = root.querySelector('[data-focus]');
        if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
      }
      var trkList = root.querySelector('.vb-trk-list'), trkCur = trkList && trkList.querySelector('.vb-st.is-current');
      if (trkCur && trkList.scrollHeight > trkList.clientHeight) trkList.scrollTop = Math.max(0, trkCur.offsetTop - (trkList.clientHeight - trkCur.offsetHeight) / 2);
      if (opts.scroll) {
        var r = root.getBoundingClientRect(), off = headerH() + 12;
        if (r.top < off) window.scrollTo({ top: window.pageYOffset + r.top - off, behavior: reduced ? 'auto' : 'smooth' });
      }
    }

    /* ---------- actions ---------- */
    function pickVehicle(h) {
      if (!vById[h]) return;
      S.vehicle = h; writeLS(VEH_KEY, h);
      S.msg = null; loadSel();
      if (S.stage && !blocked(S.stage)) {
        var i = firstIncomplete();
        if (i < 0) go('review', null, { keepMsg: true }); else go('step', i, { keepMsg: true });
      } else {
        if (S.stage && blocked(S.stage)) S.stage = null;
        go('stage', null, { keepMsg: true });
      }
    }
    function pickStage(h) {
      if (!sById[h] || blocked(h)) return;
      S.stage = h; S.addonsSeen = false;
      var i = firstIncomplete();
      if (i < 0) go('review'); else go('step', i);
    }
    function choose(c, pid) {
      if (S.adding) return;
      var p = findProduct(c, pid);
      if (!p) return;
      var v = currentVariant(c, p);
      if (!v || !v.available) { announce('That option is sold out.'); return; }
      if (inBuild(p.id, c)) {
        S.msg = { type: 'warn', text: p.title + ' is already part of your build, so it cannot be used twice.' };
        render({}); return;
      }
      S.sel[c] = { pid: p.id, vid: v.id };
      S.swapFor = null;
      saveSel();
      var text = cats[c].name + ' selected: ' + p.title + (p.single ? '' : ' (' + v.title + ')');
      announce(text + '. ' + savingsSentence());
      S.msg = { type: 'ok', text: text };
      advance(S.step);
    }
    function chooseSwap(c, pid) {
      if (S.adding || !canSwap(c)) return;
      var p = findSwap(pid);
      if (!p || !swapCandidates(c).some(function (x) { return x.id === pid; })) return;
      var v = currentVariant(c, p);
      if (!v || !v.available) { announce('That option is sold out.'); return; }
      S.sel[c] = { swap: true, pid: p.id, vid: v.id };
      S.swapFor = null;
      saveSel();
      var text = cats[c].name + ' swapped for: ' + p.title + (p.single ? '' : ' (' + v.title + ')');
      announce(text + '. ' + savingsSentence());
      S.msg = { type: 'ok', text: text + '. It counts once, in place of ' + cats[c].name.toLowerCase() + '.' };
      advance(S.step);
    }
    function skip(c) {
      if (S.adding || !canSkip(c)) return;
      S.sel[c] = { skip: true };
      S.swapFor = null;
      saveSel();
      announce(cats[c].name + ' skipped. ' + savingsSentence());
      S.msg = { type: 'ok', text: cats[c].name + ' skipped. It will not be added to your cart.' };
      if (S.view === 'step' && stepCats()[S.step] === c) advance(S.step); else render({});
    }
    function chooseAddon(c, pid) {
      if (S.adding) return;
      var p = findProduct(c, pid);
      if (!p) return;
      var v = currentVariant(c, p), cur = S.sel[c];
      if (cur && cur.pid === p.id && cur.vid === v.id) {
        delete S.sel[c];
        announce(p.title + ' removed from your build.');
      } else {
        if (!v || !v.available) { announce('That option is sold out.'); return; }
        if (inBuild(p.id, c)) { S.msg = { type: 'warn', text: p.title + ' is already part of your build.' }; render({}); return; }
        S.sel[c] = { pid: p.id, vid: v.id };
        announce(p.title + ' added to your build.');
      }
      S.msg = null;
      saveSel();
      render({});
      refocus(`[data-act='choose-addon'][data-pid='${pid}']`);
    }
    function addExtra(c) {
      if (S.adding || !cats[c] || !isCarbon(c) || S.extras.indexOf(c) !== -1 || mainCats(stage()).indexOf(c) !== -1 || !fillable(c)) return;
      S.extras.push(c);
      saveSel();
      announce(cats[c].name + ' added as an extra part. Choose a product to count it toward your savings.');
      S.msg = null;
      go('step', stepCats().indexOf(c));
    }
    function remove(c) {
      if (S.adding || !cats[c]) return;
      var cur = S.view === 'step' ? stepCats()[S.step] : null, wasExtra = isExtra(c), text;
      if (wasExtra) {
        S.extras = S.extras.filter(function (x) { return x !== c; });
        delete S.sel[c];
        text = cats[c].name + ' removed from your build';
      } else if (kindOf(c) === 'addon') {
        delete S.sel[c];
        text = cats[c].name + ' removed from your build';
      } else {
        S.sel[c] = { skip: true };
        text = cats[c].name + ' removed. It is now skipped';
      }
      S.swapFor = null;
      saveSel();
      announce(text + '. ' + savingsSentence());
      S.msg = null;
      if (wasExtra && cur === c) go('step', Math.max(0, S.step - 1));
      else { pushUrl(true); render({}); }
    }
    function refreshCartBubble() {
      try {
        if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return;
        fetch((routes.root || '/') + '?sections=cart-count', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (sec) { window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: { sections: sec } }); })
          .catch(function () { /* header count refreshes on the next page load */ });
      } catch (e) { /* theme event bus not present */ }
    }
    function cartUrl(path) { return (routes.cart || '/cart') + path; }
    /* Cart lines that belong to one add attempt: every line of a package carries the same _vlt_pkg_id. */
    function packageLines(pid) {
      return fetch(cartUrl('.js'), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart read failed'); return r.json(); })
        .then(function (cart) { return (cart.items || []).filter(function (i) { return i.properties && i.properties._vlt_pkg_id === pid; }); });
    }
    /*
     * After a failed add, leave the cart holding all of the package or none of it, never part of it.
     * Resolves 'added' (it worked and only the reply was lost), 'none', 'removed' (stray lines taken out) or 'unknown'.
     */
    function settle(pid, expected) {
      return packageLines(pid).then(function (lines) {
        if (lines.length >= expected) return 'added';
        if (!lines.length) return 'none';
        var updates = {};
        lines.forEach(function (l) { updates[l.key] = 0; });
        return fetch(cartUrl('/update.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.ok ? 'removed' : 'unknown'; });
      }).catch(function () { return 'unknown'; });
    }
    /* Only say the savings are applied once the cart itself shows a discount on this package's lines. */
    function verifyApplied(pid) {
      packageLines(pid).then(function (lines) {
        var sum = 0;
        lines.forEach(function (l) { sum += num(l.total_discount, 0); });
        var msg = sum > 0
          ? 'Your package savings are applied in your cart: ' + money(sum) + ' off.'
          : (live ? 'Your cart is showing individual prices. Check your cart and checkout for the package discount before you pay.' : '');
        if (S.added) S.added.applied = msg;
        var el = root.querySelector('[data-applied]');
        if (el && msg) el.textContent = ' ' + msg;
      }).catch(function () { /* the cart page shows the final prices */ });
    }
    function addPackage() {
      var res = calc();
      if (!res.purchasable || S.adding) return;
      S.adding = true; S.error = '';
      render({});
      var s = stage(), v = vehicle(), pid = Core.makePackageId();
      var lines = linesNow().map(function (l) { return { variantId: l.variant.id, category: l.category, categoryName: cats[l.category].name, role: l.role }; });
      var items = Core.buildCartItems({ stage: s, vehicle: v, packageId: pid, lines: lines });
      function added() {
        S.added = { count: items.length, individual: res.individual, stageName: s.name, number: s.number, vehicleName: v.name, applied: '' };
        buildCats().forEach(function (c) { delete S.sel[c]; });
        S.extras = [];
        saveSel();
        S.adding = false;
        go('added');
        announce('Package added to your cart.');
        refreshCartBubble();
        verifyApplied(pid);
      }
      function fail(text) { S.adding = false; S.error = text; render({ focus: true }); }
      function failed(text) {
        return settle(pid, items.length).then(function (state) {
          if (state === 'added') added();
          else if (state === 'unknown') fail('We could not confirm what was added to your cart. Please check your cart before trying again.');
          else fail(sentence(text) + ' Nothing was added to your cart.');
        });
      }
      fetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (b) { return { ok: r.ok, b: b }; }, function () { return { ok: r.ok, b: {} }; });
      }, function () {
        return { ok: false, net: true, b: {} };
      }).then(function (out) {
        if (out.ok) return added();
        return failed(out.net ? 'We could not reach the store. Check your connection and try again.' : cartErrorText(out.b));
      }).catch(function () {
        fail('Something went wrong. Please check your cart before trying again.');
      });
    }

    root.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-act]') : null;
      if (!el || !root.contains(el) || el.disabled) return;
      var act = el.getAttribute('data-act'), c = el.getAttribute('data-cat');
      if (act === 'pick-vehicle') pickVehicle(el.getAttribute('data-v'));
      else if (act === 'pick-stage') pickStage(el.getAttribute('data-s'));
      else if (act === 'choose') choose(c, Number(el.getAttribute('data-pid')));
      else if (act === 'choose-swap') chooseSwap(c, Number(el.getAttribute('data-pid')));
      else if (act === 'choose-addon') chooseAddon(c, Number(el.getAttribute('data-pid')));
      else if (act === 'skip') skip(c);
      else if (act === 'mode-swap') { if (canSwap(c)) { S.swapFor = c; render({}); refocus(`[data-act='mode-swap']`); } }
      else if (act === 'mode-select') {
        var r = S.sel[c];
        if (r && (r.skip || r.swap)) { delete S.sel[c]; saveSel(); }
        S.swapFor = null; render({}); refocus(`[data-act='mode-select']`);
      }
      else if (act === 'filter') { S.filter[c] = el.getAttribute('data-v') || ''; render({}); refocus(`[data-act='filter'][data-v='${el.getAttribute('data-v') || ''}']`); }
      else if (act === 'add-extra') addExtra(c);
      else if (act === 'remove') remove(c);
      else if (act === 'to-addons') go('addons');
      else if (act === 'goto') go('step', Number(el.getAttribute('data-i')));
      else if (act === 'prev') {
        if (S.view === 'review') { if (addonCats().length) go('addons'); else go('step', stepCats().length - 1); }
        else if (S.view === 'addons') go('step', stepCats().length - 1);
        else if (S.step > 0) go('step', S.step - 1);
      }
      else if (act === 'next') { if (S.step < stepCats().length - 1) go('step', S.step + 1); else if (firstIncomplete() === -1) afterSteps(); else go('step', firstIncomplete()); }
      else if (act === 'review') go('review');
      else if (act === 'add') addPackage();
      else if (act === 'change-vehicle') go('vehicle');
      else if (act === 'change-stage') { if (S.vehicle) go('stage'); else go('vehicle'); }
      else if (act === 'to-build') { var i = firstIncomplete(); if (i < 0) go('review'); else go('step', i); }
      else if (act === 'again') { S.added = null; go('stage'); }
      else if (act === 'toggle-sheet') {
        S.open = !S.open;
        var side = root.querySelector('.vb-side');
        if (side) side.classList.toggle('is-open', S.open);
        el.setAttribute('aria-expanded', S.open ? 'true' : 'false');
        if (S.open && side) {
          /* An open sheet is taller than the bar: scroll so its bottom edge, and the bar with it, stays on screen. */
          var sr = side.getBoundingClientRect();
          if (sr.bottom > window.innerHeight) window.scrollBy({ top: sr.bottom - window.innerHeight, behavior: reduced ? 'auto' : 'smooth' });
        }
      }
    });
    root.addEventListener('change', function (e) {
      var sel = e.target;
      if (!sel || sel.tagName !== 'SELECT' || !sel.hasAttribute('data-pid')) return;
      var c = sel.getAttribute('data-cat'), pid = Number(sel.getAttribute('data-pid')), mode = sel.getAttribute('data-mode') || 'select';
      var p = mode === 'swap' ? findSwap(pid) : findProduct(c, pid);
      if (!p) return;
      S.pick[c + ':' + pid] = Number(sel.value);
      var card = root.querySelector(`[data-card='${pid}']`);
      if (!card) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = cardHtml(c, p, mode);
      card.replaceWith(tmp.firstElementChild);
      var ns = root.querySelector(`[data-card='${pid}'] select`);
      if (ns) ns.focus();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && S.open) {
        S.open = false;
        var side = root.querySelector('.vb-side');
        if (side) side.classList.remove('is-open');
        var t = root.querySelector('.vb-bar-t');
        if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
      }
    });
    window.addEventListener('popstate', function () {
      if (!document.body.contains(root)) return;
      fromUrl();
      render({ focus: true });
    });

    fromUrl();
    pushUrl(true);
    render({});
    root.__vb = { state: S, calc: calc, prods: prods, swap: swapList, tiers: tiers, meter: function () { return meterInfo(calc()); } };
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-vb-root]'), function (h) {
      if (h.__vbInit) return;
      h.__vbInit = true;
      new App(h);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
